import { UPDATE_SALON_INFORMATION } from '../constants';

type ActionType = 'SALON/UPDATE_INFORMATION'
  | 'SALON/UPDATE_SERVICES'
  ;
interface Action {
  type: ActionType;
  payload: any;
}

export const defaultState = {
  serviceGroups: [],
};

export const UPDATE_SALON_SERVICES = 'SALON/UPDATE_SERVICES';

export function salonReducer(state = defaultState, action: Action) {
  switch (action.type) {
    case UPDATE_SALON_INFORMATION:
      return { ...state, ...action.payload };

    case UPDATE_SALON_SERVICES:
      return { ...state, serviceGroups: action.payload };

    default:
      return state;
  }
}
